<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'CardsRecords',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'userName',
        placeholder: '用户',
        type: 'input'
      }, {
        name: 'status',
        placeholder: '是否到期',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '是',
        }, {
          key: 0,
          value: '否',
        }]
      }],
      permission: {
        add: 'cardsRecords:add',
        update: 'cardsRecords:update',
        delete: 'cardsRecords:delete',
        deleteBatch: 'cardsRecords:deleteBatch'
      },
      url: {
        get: '/cardsRecords/listByCondition',
        add: '/cardsRecords/add',
        update: '/cardsRecords/update',
        delete: '/cardsRecords/delete',
        delete_batch: '/cardsRecords/deleteBatch',
        status: '/cardsRecords/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          detail: false,
          width: '',
        }, {
          field: 'cardsId',  // 字段名
          label: '卡密ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'number',  // 字段名
          label: '天数',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'price',  // 字段名
          label: '价格',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'videoNumber',  // 字段名
          label: '视频数量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'userId',  // 字段名
          label: '用户ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'userName',  // 字段名
          label: '用户',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'usageTime',  // 字段名
          label: '使用时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'expiryTime',  // 字段名
          label: '到期时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [
              {
                key: 1,
                value: '是',
                type: 'success'
              }, {
                key: 0,
                value: '否',
                type: 'info'
              }
            ]
          },
          width: '80',
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              {required: true, message: 'agentId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'cardsId',  // 字段名
            label: 'cardsId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入cardsId',
            rules: [
              {required: true, message: 'cardsId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: true, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'expiryTime',  // 字段名
            label: 'expiryTime',  // 字段显示名称
            type: 'input',
            placeholder: '请输入expiryTime',
            rules: [
              {required: true, message: 'expiryTime不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
